"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastComment = void 0;
const sortMessages_1 = __importDefault(require("./sortMessages"));
function getLastComment(item) {
    try {
        const messages = (0, sortMessages_1.default)((item === null || item === void 0 ? void 0 : item.messages) || []);
        return messages.length > 0 ? messages[messages.length - 1] : undefined;
    }
    catch (_a) { }
}
exports.getLastComment = getLastComment;
exports.default = getLastComment;
